module.exports = __webpack_public_path__ + "static/media/arrow-up-left.25fea0f9.svg";